import { getBackgroundCSS, getBorderCSS, getColorsCSS, getSpaceCSS, getTypoCSS } from '../../Components/Helper/getCSS';

const Style = ({ attributes, clientId, itemWidth }) => {
	const { columnGap, rowGap, isPopupWidthAsRatio, background, padding, border, filterBtnTypo, filterBtnColors, filterBtnHoverColors, itemHeight } = attributes;

	return <style dangerouslySetInnerHTML={{
		__html: `
		${getTypoCSS(filterBtnTypo)?.googleFontLink}

		#vgbVideoGallery-${clientId} .vgbVideoGallery{
			${getBackgroundCSS(background)}
			padding: ${getSpaceCSS(padding)};
			${getBorderCSS(border)}
			box-shadow: 0px 25px 30px -20px rgba(0, 0, 0, 0.2);
		}
		#vgbVideoGallery-${clientId} .vgbVideoGallery .filter button{
			${getTypoCSS(filterBtnTypo)?.styles}
			${getColorsCSS(filterBtnColors)}
		}
		#vgbVideoGallery-${clientId} .vgbVideoGallery .filter button:hover,
		#vgbVideoGallery-${clientId} .vgbVideoGallery .filter button.current{
			${getColorsCSS(filterBtnHoverColors)}
		}
		#vgbVideoGallery-${clientId} .vgbVideoGallery .vgbColumnSizer {
			grid-column-gap: ${columnGap}px;
		}
		#vgbVideoGallery-${clientId} .vgbVideoGallery .videoGallery .galleryItem{
			width: ${itemWidth}px;
			height: ${itemHeight};
			margin-bottom: ${rowGap}px;
		}

		${isPopupWidthAsRatio ? `
			.vgbFancyBox-${clientId} .fancybox-content{
				background: #0000 !important;
			}
			.vgbFancyBox-${clientId} .plyr{
				width: fit-content;
			}
			.vgbFancyBox-${clientId} .plyr .plyr__controls{
				justify-content: flex-start;
			}
		` : ''}
		`.replace(/\s+/g, ' ')
	}} />
}
export default Style;